import React, { useState, useEffect } from "react";
import axios from "axios";
import { Radio, Table, Input, DatePicker, Modal, Button, Menu, Col, Row, Switch, message, Space } from "antd";
import { Link, useParams, useNavigate } from "react-router-dom";
import { InboxOutlined, PlusOutlined, EditOutlined, ExclamationCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import AdminLessonModal from "./components/AdminLessonModal";
import NewTable from "./components/NewTable";
import './css/TableTitle.css'
const { RangePicker } = DatePicker;
const LessonList = () => {
    const [total, set_total] = useState(1);
    const [extra_columns, set_extra_columns] = useState(null);
    const [loading, set_loading] = useState(0)
    const [force_reload, set_force_reload] = useState(0)
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [title, setTitle] = useState();
    const [edit, setEdit] = useState(false);
    const [open, setOpen] = useState(false);
    const [color, setColor] = useState('d65b77');
    const [messageApi, contextHolder] = message.useMessage();
    const [data, setData] = useState([]);
    const { confirm } = Modal;
    const [msg, setMsg] = useState(0);
    const [datas, setDatas] = useState([{}])
    const [editcard, setEditCard] = useState([{}]);
    const [choose_column, set_choose_column] = useState([]);
    const [custom_filter_value, set_custom_filter_value] = useState(null);
    const [wait_loading, set_wait_loading] = useState(false);
    const [import_modal, set_import_modal] = useState(false);
    const [upload_modal, set_upload_modal] = useState(false);
    const [importData, setImportData] = useState([]);
    const navigate = useNavigate();
    const columns = [
        {
            title: '名稱',
            key: 'name',
            dataIndex: 'name',
            align: 'center',
        },
        {
            title: '課程分類名稱',
            key: 'lesson_category_name',
            dataIndex: 'lesson_category_name',
            align: 'center',
        },
        {
            title: '課程大綱',
            key: 'outline',
            dataIndex: 'outline',
            align: 'center',
        },
        {
            title: '操作',
            align: 'center',
            render: (text, record, index) => (
                <>
                    <Button type="text" style={{ color: 'rgba(43, 193, 123, 1)' }} onClick={e => { setTitle('修改課程'); setColor('f09a45'); setEdit(true); setOpen(true); handleOnEdit(record); setEditCard(record) }} >編輯</Button>
                    <Button danger type="text" onClick={() => showMessage(record.lesson_id)}>刪除</Button>
                </>
            )

        },
    ]
    useEffect(() => {
        get_datas()
    }, []);
    const handleOnEdit = (key) => {
        setTitle('修改課程');
        setColor('f09a45');
        setEdit(true);
        setEditCard(key);
    }
    const handleEdit = () => {
        setOpen(false);
        axios
            .patch(`/cramSchool/api/lesson`, [{ ...editcard }])
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '修改失敗',
                    });
                    get_datas();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '修改成功',
                    });
                    get_datas();
                }
            })
        // console.log(editcard);
    }
    const showMessage = (value) => {
        confirm({
            title: '確定要刪除嗎',
            icon: <ExclamationCircleOutlined />,
            okText: '確定',
            okType: 'primary',
            cancelText: '取消',
            onOk() {
                handleOnDelete(value);
            },
            centered: true
        });
    };
    const rowSelection = {
        selectedRowKeys: selectedRowKeys,
        onSelectAll: (selected, selectedRows, changeRows) => {
            if (selectedRowKeys.length !== 0) {
                setSelectedRowKeys([]);
            }
        },
        onChange: (selectedRowKeys, selectedRows) => {
            setSelectedRowKeys(selectedRowKeys);

        },

    };
    const handleOnDelete = (value) => {
        axios
            .delete(`/cramSchool/api/lesson`, {
                data: [{ lesson_id: value }]
            })
            .then((response) => {
                // console.log(response)
                if (response.data.status == 'success') {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '刪除成功',
                    });
                    get_datas();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '刪除失敗',
                    });
                    get_datas();
                }
            })
    }
    const handleOnDeleteAll = () => {
        if (selectedRowKeys.length == 0) {
            messageApi.open({
                type: 'error',
                content: '請選擇資料',
            });
        } else {
            const deleterow = [];
            selectedRowKeys.map((value) => {
                const data_tmp = {};
                data_tmp['lesson_id'] = value;
                deleterow.push(data_tmp);
            })
            axios
                .delete(`/cramSchool/api/lesson`, {
                    data: deleterow
                })
                .then((response) => {
                    // console.log(response)
                    if (response.data.status == 'success') {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: '刪除成功',
                        });
                        get_datas();
                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: '刪除失敗',
                        });
                        get_datas();
                    }
                })
        }
    }
    const handleSubmit = () => {
        if (JSON.stringify(editcard) == '{}') {
            // setOpen(false);
            messageApi.open({
                type: 'error',
                content: '新增失敗，請填寫任一欄位',
            });
        } else {
            if (editcard.lesson_category_data.length == 0 || editcard.lesson_category_data?.length == undefined || editcard.name == '' || editcard.name == undefined) {
                messageApi.open({
                    type: 'error',
                    content: '新增失敗，請填寫必填欄位',
                });
            } else {
                axios
                    .post(`/cramSchool/api/lesson`, [editcard])
                    .then((response) => {
                        if (response.data.status == 'failure') {
                            setOpen(false);
                            messageApi.open({
                                type: 'error',
                                content: '新增失敗',
                            });
                            get_datas();
                        } else {
                            setOpen(false);
                            messageApi.open({
                                type: 'success',
                                content: '新增成功',
                            });
                            get_datas();
                        }
                    })
            }
        }
    }
    const get_datas = (param, sort, filter, checklist) => {
        set_loading(true)
        axios
            .get('/cramSchool/api/lesson', {
                params: {
                    cur_page: param?.current,
                    size: param?.pageSize,
                    custom_filter_key: checklist,
                    custom_filter_value: param?.keyword,
                    order: sort && Object.entries(sort).map(([map_key, map_value]) => ({ column: map_key, type: map_value }))
                }
            })
            .then(response => {
                set_total(response.data.total)
                setDatas(response.data.data);
            })
            .finally((error) => {
                set_loading(false)
            })

    }

    const handleOnAddRow = () => {
        setTitle('新增課程'); setColor('d65b77'); setEditCard({}); setEdit(false); setOpen(true)
    }
    const reload = () => {
        set_force_reload(prev => prev + 1)
    }
    const handleExport = () => {
        axios
            .get('/cramSchool/api/lesson_excel', {
                responseType: 'blob',
                params: {
                    custom_filter_key: choose_column,
                    custom_filter_value: custom_filter_value
                }
            })
            .then((response) => {
                const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', '課程名單.xlsx');
                document.body.appendChild(link);
                link.click();
                link.remove();
            })
    }

    const handleImportModal = (e) => {
        set_upload_modal(true);
    }
    const handleImport = (e) => {
        set_wait_loading(true);
        const files = e.target.files[0];
        let form_data = new FormData();
        form_data.append('inputFile', files);
        form_data.append('language', choose_column);
        form_data.append('columns', JSON.stringify(columns));
        axios
            .post(`/cramSchool/api/lesson_import/read_sample`, form_data)
            .then((response) => {
                set_upload_modal(false);
                if (JSON.stringify(response.data.duplicate) != '') {
                    let data_tmp = []
                    response.data.duplicate.map((item) => {
                        if (item['emergency_contact'] == undefined) {
                            data_tmp.push({ ...item, emergency_contact: [] })
                        } else {
                            return (
                                data_tmp.push(item)
                            )

                        }
                    })
                    setImportData(data_tmp);
                } else {
                    messageApi.open({
                        type: 'success',
                        content: '新增成功',
                    });
                    reload();
                }
                set_wait_loading(false)
            })
    }
    const handleDownload = () => {
        axios
            .get('/cramSchool/api/admin/manual/lesson?manual_id=5', {
                responseType: 'blob',
            })
            .then((response) => {
                const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', '教師名單範例.xlsx');
                document.body.appendChild(link);
                link.click();
                link.remove();
            })
    }
    const handleOver = (record) => {
        axios
            .patch(`/cramSchool/api/lesson`, record)
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '覆蓋失敗',
                    });
                    reload();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '覆蓋成功',
                    });
                    record && record.map((value) => {
                        setImportData(importData.filter(item => (item.name != value.name) && (item.email != value.email)))
                    })
                    reload();
                }
            })
    }
    return (
        <>
            {contextHolder}
            <AdminLessonModal
                open={open}
                edit={edit}
                title={title}
                color={color}
                setData={setData}
                data={data}
                setOpen={setOpen}
                editcard={editcard}
                setEditCard={setEditCard}
                handleEdit={handleEdit}
                handleSubmit={handleSubmit}
            />
            <Row gutter={[8, 16]} style={{ padding: '20px' }}>
                <Col span={24}>
                    <NewTable
                        total={total}
                        extra_columns={extra_columns}
                        set_extra_columns={set_extra_columns}
                        loading={loading}
                        page_name={'LessonList'}
                        force_reload={force_reload}
                        style={{ cursor: 'pointer' }}
                        getData={get_datas}
                        datas={datas}
                        columns={columns.concat(extra_columns || [])}
                        add_button_title={'新增課程'}//新增按鈕上的名稱
                        handleOnAddRow={handleOnAddRow}//新增row 內容
                        handleOnDeleteRow={handleOnDeleteAll}//多筆刪除
                        setSelectedRowKeys={setSelectedRowKeys}
                        selectedRowKeys={selectedRowKeys}
                        rowKey={'lesson_id'}
                        export={true}
                        import={true}
                        handleImportModal={handleImportModal}
                        // language_time={language_time}
                        // set_language_time={set_language_time}
                        handleImport={handleImport}
                        handleDownload={handleDownload}
                        set_upload_modal={set_upload_modal}
                        upload_modal={upload_modal}
                        setImportData={setImportData}
                        set_import_modal={set_import_modal}
                        importData={importData}
                        handleOver={handleOver}
                        // handleReserve={handleReserve}
                        import_modal={import_modal}
                        // setImportData={setImportData}
                        wait_loading={wait_loading}
                        // qrcodeNotifyPdf={true}
                        // handleQRcodeNotifyPdf={handleQRcodeNotifyPdf}
                        // qrcodeNotifyLoading={pdfLoading}
                        handleExport={handleExport}
                    />
                </Col>
            </Row>
        </>

    );
};
export default LessonList;
